import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { EquipamentoTipoLabels } from '@tivic-team/manager-ts/dist/grl';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-tipo',
  templateUrl: './dropdown-tipo.component.html',
  styleUrls: ['./dropdown-tipo.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownTipoComponent implements OnInit {

  tipoEquipamento = EquipamentoTipoLabels;

  get setValue(): string {
    return this.formGroup.get("equipamento").get("tpEquipamento").value
  }

  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

}
